"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeSelection = void 0;

/**
 * obtiene el tema correspodiente segun la funcionalidad
 * @param {object} functionalClaim claim clicable
 * @param {object} purcharseButton boton proceso de compra
 * @returns {object}
 */
const themeSelection = (functionalClaim, purcharseButton) => {
  let onlyVisualTheme = true;
  let purcharseModeTheme = false;
  let clicablePillTheme = false; // identifiación del tema

  if (functionalClaim && functionalClaim.onClick && !(purcharseButton && purcharseButton.link)) {
    clicablePillTheme = true;
    onlyVisualTheme = false;
  }

  if (!(functionalClaim && functionalClaim.onClick) && purcharseButton && purcharseButton.link) {
    purcharseModeTheme = true;
    onlyVisualTheme = false;
  }

  return [onlyVisualTheme, purcharseModeTheme, clicablePillTheme];
};

exports.themeSelection = themeSelection;

//# sourceMappingURL=utils.js.map